import * as React from "react";
import {
  MsalAuthenticationTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { Box, styled, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Dashboard,
  EmailTemplate,
  FourOFour,
  Navbar,
  SubSellerProfile,
} from "./components";
import theme from "./theme";
import {
  EventType,
  InteractionRequiredAuthError,
  InteractionType,
} from "@azure/msal-browser";
import { setMSALToken } from "./redux/slices/sellerSlice";
import { useDispatch } from "react-redux";
import CustomSnack from "./components/snackbar";
import { REQUIREDROLES } from "./utils/constants";
import axios from "axios";
import SellerData from "./components/sellerData";
import AppLoader from "./utils/appLoader";
import UserProfile from "./components/manageUsers/userProfile";
import AddAdminUser from "./components/manageUsers/addAdminUser";
import { ROLES, CHECKROLE } from "./utils/constants";
import ResponsiveTabsTable from "./components/commonComponents/paymentCatalogue";
// import { REQUIREDROLES } from "./utils/constants";

function App() {
  // const theme = useTheme();
  // const isMobile = ;

  const dispatch = useDispatch();

  const { instance } = useMsal();
  window.instance = instance;
  const isAuthenticated = useIsAuthenticated();

  const userRolesRef = React.useRef([]);
  const [value, setValue] = React.useState("0");
  const [flag, setFlag] = React.useState(false);
  const [paymentRole, setPaymentRole] = React.useState(false);
  const [hideSellerSubSeller, setHideSellerSubSeller] = React.useState(false);
  const [fopAddingName, setFopAddingName] = React.useState("");
  const [tab, setTab] = React.useState("0");

  React.useEffect(() => {
    if (!isAuthenticated) {
      instance
        .ssoSilent()
        .then((res) => {
          instance.setActiveAccount(res.account);
        })
        .catch((err) => {
          if (err instanceof InteractionRequiredAuthError) {
            instance.loginRedirect();
          }
        });
    }

    const id = instance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        event.eventType === EventType.SSO_SILENT_SUCCESS
      ) {
        instance.setActiveAccount(event.payload.account);
        userRolesRef.current = event.payload.idTokenClaims.roles;

        if (
          !event.payload.idTokenClaims?.roles?.some((role) =>
            REQUIREDROLES.includes(role)
          )
        ) {
          if (window.location.pathname !== "/page-not-found") {
            window.location.href = "/page-not-found";
          }
        }
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${event.payload.idToken}`;

        dispatch(
          setMSALToken({
            data: {
              user: event.payload.account.name,
              token: event.payload.idToken,
              user_email: event.payload.account.username,
              roles: event.payload.idTokenClaims?.roles,
            },
          })
        );
        setFopAddingName(event.payload.account.name);

        const role = event.payload.idTokenClaims?.roles?.some(
          (role) => role === ROLES.SUPER_ADMIN
        );

        if (role) {
          setFlag(true);
        } else {
          setFlag(false);
        }

        const check = event.payload.idTokenClaims?.roles?.some(
          (check) =>
            check === CHECKROLE.SUPPORT_ADMIN ||
            check === CHECKROLE.SUPPORT_USER ||
            check === ROLES.SUPER_ADMIN
        );

        if (check) {
          setPaymentRole(true);
        } else {
          setPaymentRole(false);
        }

        const checkSupportAdminUser = event.payload.idTokenClaims?.roles?.some(
          (check) =>
            check === ROLES.SUPER_ADMIN ||
            check === ROLES.BUSINESS_ADMIN ||
            check === ROLES.BUSINESS_USER ||
            check === ROLES.IT_ADMIN
        );

        if (!checkSupportAdminUser) {
          setHideSellerSubSeller(true);
        } else {
          setHideSellerSubSeller(false);
        }
      }
    });
    return () => instance.removeEventCallback(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (val) => {
    setValue(val);
  };

  const navigateHome = (val, type) => {
    if (!paymentRole && val === 3) {
      setValue(2);
      setTab(2);
    } else {
      setValue(val);
      setTab(type);
    }
  };

  // React.useEffect(() => {
  //   (async () => {
  //     console.log("instance", instance, account);
  //     try {
  //       const response = await instance.acquireTokenSilent({ account });
  //       dispatch(
  //         setMSALToken({
  //           data: {
  //             user: response.idTokenClaims.name,
  //             token: response.idToken,
  //           },
  //         })
  //       );
  //       console.log(response);
  //     } catch (error) {
  //       console.log("catchh");
  //       if (inProgress === InteractionStatus.None) {
  //         const res = await instance.loginRedirect();
  //         console.log("catch res", res);
  //       }
  //     }
  //   })();
  //   // setMSALToken({data: account})
  // }, [account]);

  // const hasRequiredRole = userRolesRef.current.some(role => REQUIREDROLES.includes(role))

  const Container = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
  }));

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Router>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
          >
            <Box
              sx={{
                top: "5rem",
                position: "fixed",
                left: "50%",
                zIndex: 1000000,
              }}
            >
              <CustomSnack />
            </Box>

            <AppLoader />

            <Routes>
              <Route path="/template" element={<EmailTemplate />} />
              <Route path="/page-not-found" element={<FourOFour />} />
              <Route
                path="/:id"
                element={
                  <Box sx={{
                    maxWidth: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                    
                    }}>
                  <Box sx={{
                    width:'1200px',
                    pl:'32px',
                    pr:'32px'
                  }}>
                    <Navbar handleChange={handleChange} />
                    <SellerData />
                  </Box>
                  </Box>
                }
              />
              <Route
                path="subseller/:id"
                element={
                  <>
                    <Navbar />
                    <SubSellerProfile navigateHome={navigateHome} />
                  </>
                }
              />
              <Route
                path="/"
                element={
                  // <ProtectedRoute >
                  <>
                    <Navbar handleChange={handleChange} />
                    <Dashboard
                      val={value}
                      type={tab}
                      flag={flag}
                      paymentRole={paymentRole}
                      fopAddingName={fopAddingName}
                      hideSellerSubSeller={hideSellerSubSeller}
                    />
                  </>
                  // </ProtectedRoute>
                }
              />
              <Route
                path="manage-user/:id"
                element={
                  <>
                    <Navbar />
                    <UserProfile navigateHome={navigateHome} />
                  </>
                }
              />
              <Route
                path="manage-user"
                element={
                  <>
                    <Navbar />
                    <AddAdminUser navigateHome={navigateHome} />
                  </>
                }
              />
              <Route
                path="payments"
                element={
                  <>
                    <Navbar />
                    <ResponsiveTabsTable />
                  </>
                }
              />
            </Routes>
          </MsalAuthenticationTemplate>
        </Router>
      </Container>
    </ThemeProvider>
  );
}

export default App;
